export default __webpack_public_path__ + "static/media/testimonials-1.54f2a70e.jpg";